import React from 'react';
import { presentVendorCardCopy } from '../shared/vendorDescription';

/**
 * Short vendor copy: the business's own words, then hours and insurance
 * on their own lines. The listing disclaimer is never shown here.
 */
export default function VendorCardCopy({ description, color, empty = '', marginBottom = '0.75rem' }) {
  const copy = presentVendorCardCopy(description);
  if (!copy.about && copy.details.length === 0) {
    if (!empty) return null;
    return (
      <p style={{ color, fontSize: '0.9rem', lineHeight: 1.5, margin: `0 0 ${marginBottom}` }}>
        {empty}
      </p>
    );
  }
  return (
    <div style={{ margin: `0 0 ${marginBottom}` }}>
      {copy.about ? (
        <p style={{
          color,
          fontSize: '0.9rem',
          lineHeight: 1.5,
          margin: copy.details.length ? '0 0 0.45rem' : 0,
          overflowWrap: 'anywhere',
          whiteSpace: 'pre-line',
        }}
        >
          {copy.about}
        </p>
      ) : null}
      {copy.details.map((line, index) => (
        <p
          key={`${index}:${line}`}
          style={{ color, fontSize: '0.9rem', lineHeight: 1.35, margin: '0.15rem 0 0', overflowWrap: 'anywhere' }}
        >
          {line}
        </p>
      ))}
    </div>
  );
}
